import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MediumDTO } from 'src/app/services/api/api';

@Component({
  selector: 'sb-comp-medium-viewer',
  templateUrl: './medium-viewer.component.html',
  styleUrls: ['./medium-viewer.component.scss'],
  standalone: false,
})
export class MediumViewerComponent implements OnInit {
  @Input() medium: MediumDTO = null;
  @Input() modalRef: NgbModalRef = null;

  showCodecWarning: boolean;

  supportedCodecs: string[] = ['av1', 'avc', 'h264', 'h263', 'mp4ves', 'mpeg1', 'mpeg2', 'theora', 'vp8', 'vp9'];

  constructor(public modal: NgbModal) {
    this.showCodecWarning = false;
  }

  ngOnInit() {
    if (this.medium?.contentType?.indexOf('video') !== -1) {
      if (this.medium && this.medium.format && this.medium.format.videoCodec) {
        const format = this.medium.format.videoCodec.split(' ');
        if (format.length === 2) {
          this.showCodecWarning = !(
            this.supportedCodecs.includes(format[0].toLowerCase()) || this.supportedCodecs.includes(format[1].toLowerCase())
          );
        } else {
          this.showCodecWarning = true;
        }
      } else {
        this.showCodecWarning = true;
      }
    }
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
}
